export enum ApptStatusEnum {
  /**
   * @deprecated Retired status. New appointments default to Unconfirmed instead.
   * Kept only so pre-existing appointments still carrying this value can be recognized
   * and normalized — do not assign it to new appointments.
   */
  Created             = '00000072-0000-0000-0000-000000000001',
  Pending_Acceptance  = '00000072-0000-0000-0000-000000000002',
  Filling_Forms       = '00000072-0000-0000-0000-000000000003',
  Forms_Filed         = '00000072-0000-0000-0000-000000000004',
  Remote_Checked_In   = '00000072-0000-0000-0000-000000000005',
  Checked_in          = '00000072-0000-0000-0000-000000000006',
  Canceled            = '00000072-0000-0000-0000-000000000007',
  Confirmed           = '00000072-0000-0000-0000-000000000008',
  Arrived             = '00000072-0000-0000-0000-000000000009',
  Seated              = '00000072-0000-0000-0000-000000000010',
  Unconfirmed         = '00000072-0000-0000-0000-000000000011',
  Checked_out         = '00000072-0000-0000-0000-000000000012',
  No_Show             = '00000072-0000-0000-0000-000000000013',
  Reschedule          = '00000072-0000-0000-0000-000000000014',
  ReadyToCheckOut     = '00000072-0000-0000-0000-000000000015',
}
